import { FunctionComponent, useEffect, useState } from "react";
import { useOrderCreateCtx } from "../../../../../context_providers/order_create_context";
import { OrderType } from "../../../../../utils/enums";
import CustomerWidget from "./customer/customer_widget";
import NewDeliveryProfileWidget from "./billing_profile/new_delivery_profile_widget";
import NewBillingProfileWidget from "./billing_profile/new_billing_profile_widget";

interface CustomerSectionWidgetProps {}

const CustomerSectionWidget: FunctionComponent<
  CustomerSectionWidgetProps
> = () => {
  const { order, setOrder, user } = useOrderCreateCtx();

  return (
    <>
      {" "}
      <div
        id="order-create-order-type-section"
        className="grid grid-cols-1 md:grid-cols-4 text-sm bg-white p-1.5 md:p-5 justify-center rounded-lg"
      >
        <div className="hidden md:block"></div>
        <div className="flex flex-wrap gap-2 col-span-1 md:col-span-3">
          <h3 className="  font-semibold ">Order Type</h3>
          {Object.values(OrderType).map((type, i) => {
            const typeId = `order-create-order-type-${type
              .toLowerCase()
              .replace(/\s+/g, "-")}`;
            return (
              <div className="mr-3 flex gap-1" key={i}>
                <input
                  onChange={(e) => {
                    setOrder((ol) => ({ ...ol, type }));
                  }}
                  className="mx-2"
                  type="radio"
                  checked={order.type === type}
                  name="order-type"
                  required
                  id={typeId}
                />
                <label className="" htmlFor={typeId}>
                  {type}
                </label>
              </div>
            );
          })}
        </div>
      </div>
      <div className="w-full my-5 flex flex-col gap-5">
        <div className="grid grid-cols-1 md:grid-cols-4 bg-white rounded-lg ">
          <div className="text-lg font-semibold p-1.5 md:p-5 flex justify-center items-center">
            Customer/User<span className="text-base text-red-500">*</span>
          </div>
          <div
            id="order-create-customer-section"
            className="col-span-1 md:col-span-3 bg-gray-50 p-1.5 md:p-5 md:py-10 rounded-md"
          >
            <CustomerWidget />
          </div>
        </div>

        {user && (
          <>
            <div className="grid grid-cols-1 md:grid-cols-4 bg-white rounded-lg ">
              <div className="text-lg font-semibold p-1.5 md:p-5 flex justify-center items-center">
                Delivery Address
                <span className="text-base text-red-500">*</span>
              </div>
              <div
                id="order-create-delivery-address-section"
                className="col-span-1 md:col-span-3 min-w-0 bg-gray-50 p-1.5 md:p-5 rounded-md"
              >
                <NewDeliveryProfileWidget />
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-4 bg-white rounded-lg ">
              <div className="text-lg font-semibold p-1.5 md:p-5 flex justify-center items-center">
                Billing Address
                <span className="text-base text-red-500">*</span>
              </div>
              <div
                id="order-create-billing-address-section"
                className="col-span-1 md:col-span-3 min-w-0 bg-gray-50 p-1.5 md:p-5 rounded-md"
              >
                <NewBillingProfileWidget />
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default CustomerSectionWidget;
